import * as React from 'react'
import { ReactElement, useContext, useMemo } from 'react'
import Card from '../Card'
import Loading from '../Loading'
import { makeStyles, mergeClasses, shorthands, Text, tokens } from '@fluentui/react-components'
import MessageContext from '../../context/MessageContext'
import { formatFullDateTime } from '../../helpers/dateHelper'
import { useTranslation } from 'react-i18next'
import PersonAvatar from '../PersonAvatar'

const useStyles = makeStyles({
    card: {
        ...shorthands.margin(0, tokens.spacingHorizontalL),
    },
    container: {
        display: 'grid',
        gridTemplateColumns: '1fr 9fr 2fr',
        ...shorthands.gap(tokens.spacingHorizontalL, tokens.spacingVerticalM),
        ...shorthands.margin(tokens.spacingVerticalM, 0),
        alignItems: 'center',
    },
    description: {
        display: 'grid',
    },
    datetime: {
        display: 'grid',
        textAlign: 'end',
    },
})

function Body(): ReactElement {
    const styles = useStyles()
    const { t: translate } = useTranslation()

    const { outlookMessage, message } = useContext(MessageContext)
    const outlookMessageRead = useMemo(() => outlookMessage as Office.MessageRead, [outlookMessage])

    return (
        <div>
            <Text size={500}>{outlookMessageRead?.subject?.toString()}</Text>
            <div className={mergeClasses(styles.container)}>
                <PersonAvatar name={outlookMessageRead?.from?.displayName} color="colorful" size={48} />
                <div className={mergeClasses(styles.description)}>
                    <Text>{outlookMessageRead?.from?.displayName || outlookMessageRead?.from?.emailAddress}</Text>
                    <Text>
                        {translate('email.filing.to')}
                        :&nbsp;
                        {outlookMessageRead?.to
                            ?.map(recipient => recipient.displayName || recipient.emailAddress)
                            .join(', ')}
                    </Text>
                </div>
                <Text>{formatFullDateTime(message.data?.sentDateTime || outlookMessageRead?.dateTimeCreated)}</Text>
            </div>
        </div>
    )
}

export default function FileMessageHeader(): ReactElement {
    const styles = useStyles()
    const { t: translate } = useTranslation()

    const { outlookMessage, message } = useContext(MessageContext)
    const outlookMessageRead = useMemo(() => outlookMessage as Office.MessageRead, [outlookMessage])

    if (message.loading) {
        return <Loading label={translate('base.loading')} />
    }

    return (
        <Card className={styles.card}>
            {!outlookMessageRead && <Text block>{translate('email.filing.dialog.subject_zero')}</Text>}
            {outlookMessageRead && <Body />}
        </Card>
    )
}
